/**
 * Stickers admin report layout (Figma 10067:28212). Use spacing tokens in class
 * strings; raw px only where Figma specifies a frame size with no token.
 */

/** Summary card: space between heading and value (CardContent default gap-16 reads loose here). */
export const SUMMARY_CARD_VALUE_GAP = 'tw:pt-(--spacing-8)';

/** Placeholder for CardBodyNumeric while loading (36px display size). */
export const SUMMARY_CARD_VALUE_SKELETON = 'tw:h-[36px] tw:w-[120px]';

/** Chart card content gap (padding uses CardContent default / Container default 16px). */
export const CHART_CARD_CONTENT = 'tw:gap-(--spacing-12)';

/** Chart card: Figma chartArea height (160px bars + x-axis labels). */
export const CHART_PLOT_HEIGHT = 'tw:h-[176px]';

/** Info tooltips in this report (Figma Tooltip Content width). */
export const REPORT_INFO_TOOLTIP_CLASS = 'tw:max-w-[200px]';

/** Route fallback skeletons — frame heights with no matching spacing tokens. */
/** 24+24 header + 8 value gap + 36 numeric + 24 bottom padding (matches loaded summary card). */
export const SUMMARY_CARD_SKELETON_HEIGHT = 'tw:h-[116px]';
/** 16+16 padding + 24 title + 12 gap + 176 chart (matches loaded DailyActivityChart card). */
export const CHART_CARD_SKELETON_HEIGHT = 'tw:h-[244px]';
